export function resolveSubscriptionReturn(value: unknown): string {
    return typeof value === 'string' && value.length <= 2048 && /^\/subscription(?:\?[^#]*)?$/.test(value)
        ? value : '/';
}

export function loginLocationAfterSessionExpired(pathname: string, search: string): string {
    const target = resolveSubscriptionReturn(pathname + search);
    return target === '/' ? '/login' : `/login?subscriptionReturn=${encodeURIComponent(target)}`;
}
